import {
  primaryColor,
  roseColor,
  greyColor,
  whiteColor,
  textInvertColor,
} from './material-dashboard-react';

const icwStyle = (theme) => ({
  // General CSS
  aButton: {
    color: '#000',
  },
  root: {
    width: '100%',
  },
  fixed: {
    position: 'fixed',
  },
  paper: {
    padding: theme.spacing(2),
  },
  appBar: {
    background: 'transparent',
    boxShadow: 'none',
  },
  bold: {
    fontWeight: 'bold !important',
  },
  hidden: {
    display: 'none',
    visibility: 'hidden',
  },
  noMargin: {
    margin: '0',
  },
  noPadding: {
    padding: 0,
  },
  noVerticalPadding: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  noInlinePadding: {
    paddingLeft: 0,
    paddingRight: 0,
  },
  noTextDecoration: {
    textDecoration: 'none',
  },
  marginLeft: {
    marginLeft: '10px',
  },
  paddingBlock: {
    padding: '20px',
  },
  divider: {
    border: '0.3px solid #e3e3e3',
    width: '100%',
  },
  primaryColor: {
    color: primaryColor,
  },
  dangerousColor: {
    color: roseColor,
  },
  textAlignLeft: {
    textAlign: 'left',
  },
  textAlignCenter: {
    textAlign: 'center',
  },
  textAlignBottom: {
    verticalAlign: 'text-bottom',
  },
  questionText: {
    margin: '30px',
    marginLeft: '15px',
  },
  avatar: {
    margin: 10,
  },
  verticalAlign: {
    display: 'flex',
    WebkitBoxAlign: 'center',
    MsFlexAlign: 'center',
    alignItems: 'center',
  },
  inputFormControl: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  inputLabel: {
    marginLeft: '15px',
  },
  filterLabel: {
    marginLeft: '15px',
    lineHeight: '46px',
  },
  fullWidthElement: {
    margin: '30px',
    display: 'block',
  },
  tableResults: {
    margin: '30px',
    height: '300px',
    overflowY: 'scroll',
  },
  textArea: {
    fontSize: '1em',
    width: '100%',
    minHeight: '100px',
    border: '1px solid rgba(200,200,200,1)',
    borderRadius: '4px',
    boxSizing: 'border-box',
    marginTop: theme.spacing(1),
    resize: 'none',
  },
  textAreaWithNoBorder: {
    fontSize: '1em',
    width: '100%',
    minHeight: '100px',
    border: 0,
    borderRadius: '4px',
    boxSizing: 'border-box',
    marginTop: theme.spacing(1),
    resize: 'none',
  },
  button: {
    margin: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  buttonText: {
    fontSize: '16px',
  },
  mandatory: {
    color: theme.palette.error.main,
    fontSize: theme.typography.fontSize * 1.2,
    fontWeight: theme.typography.fontWeightMedium,
    verticalAlign: 'super',
  },
  productInputPanel: {
    width: '100%',
    margin: '10px',
  },
  left: {
    float: 'left',
  },
  leftIcon: {
    marginRight: theme.spacing(1),
  },
  right: {
    float: 'right',
  },
  rightIcon: {
    marginLeft: theme.spacing(1),
  },
  iconSmall: {
    fontSize: 20,
  },
  tableResponsive: {
    height: '68vh',
  },
  statusMsg: {
    backgroundColor: 'green',
  },
  errorMsg: {
    backgroundColor: 'red',
  },
  progress: {
    margin: theme.spacing(2),
  },
  card: {
    // maxWidth: 400,
    marginBottom: theme.spacing(1),
  },
  companyAvatar: {
    margin: 'auto',
    display: 'block',
    width: '100%',
    height: 200,
  },

  // Analytic Page CSS
  analyticResult: {
    marginTop: '25px',
  },

  analyticContainer: {
    backgroundColor: whiteColor,
  },
  // End of Analytic Page CSS

  iconInButton: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  inlineBlock: {
    display: 'inline-block',
    paddingRight: theme.spacing(1),
  },
  chip: {
    height: 26,
    margin: theme.spacing(0.25),
  },
  chipAvatar: {
    height: '16px',
    width: '16px',
    margin: `0 ${theme.spacing(0.625)}px`,
    fontSize: 12,
    fontWeight: theme.typography.fontWeightMedium,
    color: '#000',
    backgroundColor: whiteColor,
  },
  chipDeleteIcon: {
    color: greyColor,
    fontSize: 18,
    marginLeft: 0,
  },
  filterChip: {
    color: textInvertColor,
    backgroundColor: '#000',
  },
  block: {
    display: 'block',
    boxShadow: 'box-sizing',
    padding: theme.spacing(1, 2),
  },
  blockPaddingTop: {
    paddingTop: theme.spacing(4),
  },
  blockPaddingBottom: {
    paddingBottom: theme.spacing(4),
  },
  inputBlock: {
    marginLeft: 15,
    marginRight: 15,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  title: {
    display: 'none',
  },
  search: {
    position: 'relative',
    marginTop: '30px',
  },
  searchIcon: {
    width: theme.spacing(9),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
    width: '200px',
  },
  inputInput: {
    paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(10),
    transition: theme.transitions.create('width'),
    width: '200px',
    border: '1px solid black',
    borderRadius: '3px',
  },
  supplierClassification: {
    height: '63px',
  },
  required: {
    color: '#CE0000',
  },
  entryHeader: {
    fontSize: '28px',
    color: '#000',
  },
  fieldTitle: {
    fontSize: '16px',
    fontWeight: '600',
  },
  fieldCaption: {
    fontSize: '12px',
    fontWeight: '600',
  },
  phoneLabel: {
    paddingTop: '10px',
    paddingLeft: '8px',
  },
  fieldReminder: {
    fontWeight: '500',
    fontSize: '16px',
  },
  radio: {
    paddingLeft: '12px',
    '& span': {
      fontSize: '16px',
    },
  },
  stepper: {
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: '25px',
    marginBottom: '5px',
    width: '500px',
  },
  stepLabel: {
    fontSize: '1.5em',
    cursor: 'pointer',
  },
  gridMargin: {
    margin: '20px 0',
  },
  outlineButton: {
    boxShadow: 'unset',
    backgroundColor: 'unset',
    color: '#0c91c4',
    border: '1px solid rgba(12, 145, 196, 0.5)',
    '&:hover': {
      boxShadow: 'unset',
      backgroundColor: 'transparent',
      color: '#0c91c4',
    },
    '&:focus': {
      color: '#0c91c4',
    },
  },
  noBorderExpansion: {
    boxShadow: 'unset !important',
    width: '100%',
  },
  noBorderSearchBar: {
    boxShadow: 'unset !important',
    padding: '10px',
    width: '90%',
  },
  loadingBlock: {
    textAlign: 'center',
    padding: '200px',
  },
  dialogBlock: {
    width: '50vw !important',
    height: '50vw !important',
    maxWidth: '50vw !important',
    maxHeight: '50vw !important',
  },
  pickerWrapper: {
    width: '100%',
    marginTop: '3px !important',
    '& input': {
      fontSize: 12,
    },
  },
});

export default icwStyle;
